import React from 'react'
import MaterialSymbol from '../material-symbol'

const AddToPhotos = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="add_to_photos" {...props} />
))

AddToPhotos.displayName = 'AddToPhotos'

export default AddToPhotos
